import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, startWith } from 'rxjs/operators';
import { requestActions } from './apiHelpers';
import { ReduxAction } from '../types';
import { apiObservable, searchApiObservable } from '@support/api';
import { alertUser } from './alerts';
import { pluralize } from '@support/string';

/* Epic actions */
const birthdayRequestRecommendationActions = requestActions('BIRTHDAY_REQUEST_RECOMMENDATIONS', [
  'fetch',
]);
const birthdayRequestEmailsActions = requestActions('BIRTHDAY_REQUEST_EMAILS', ['create']);

/* Component actions */
export const fetchBirthdayRequestRecommendations = birthdayRequestRecommendationActions['fetch'];
export const requestBirthdays = birthdayRequestEmailsActions['create'];

/* Epics */
const fetchBirthdayRequestRecommendationsEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_BIRTHDAY_REQUEST_RECOMMENDATIONS'),
    mergeMap(() =>
      searchApiObservable('POST', 'search', {
        body: {
          term: 'all',
          birthdays: false,
          email: true,
        },
      }).pipe(
        map(birthdayRequestRecommendationActions['fetchSucceeded']),
        startWith(birthdayRequestRecommendationActions['fetchRequested']()),
        catchError((err) => of(birthdayRequestRecommendationActions['fetchFailed'](err))),
      ),
    ),
  );

const createBirthdaysRequestEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('CREATE_BIRTHDAY_REQUEST_EMAILS'),
    mergeMap(({ payload }) =>
      apiObservable('POST', '/network/contacts/add-birthdays/', {
        contact_ids: payload.contactIDs,
      }).pipe(
        map((response) =>
          birthdayRequestEmailsActions['createSucceeded']({
            ...response,
            contactIDs: payload.contactIDs,
          }),
        ),
        startWith(birthdayRequestEmailsActions['createRequested']()),
        catchError((err) => of(birthdayRequestEmailsActions['createFailed'](err))),
      ),
    ),
  );

const alertUserOnBirthdayRequestEmailsQueuedEpic = (action$: Observable<ReduxAction>) => {
  return action$.pipe(
    ofType('CREATE_BIRTHDAY_REQUEST_EMAILS_SUCCEEDED'),
    map(({ payload }) => {
      const count = payload.contactIDs.length;
      return alertUser(
        `Birthday requests sent to ${count} ${pluralize(count, 'person')}`,
        'success',
      );
    }),
  );
};

export const birthdaysEpic = combineEpics(
  fetchBirthdayRequestRecommendationsEpic,
  createBirthdaysRequestEpic,
  alertUserOnBirthdayRequestEmailsQueuedEpic,
);
